import Breadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import { useAppSelector } from 'app/hooks'
import { Link } from 'react-router-dom'

export default function BC() {
  const breadcrumbs = useAppSelector((s) => s.UI.breadcrumbs)
  return (
    <Breadcrumbs sx={{ my: 1 }}>
      {breadcrumbs.map((v, i) => {
        if (i === breadcrumbs.length - 1) {
          return (
            <Typography key={i} color="text.primary">
              {v.text}
            </Typography>
          )
        } else
          return (
            <Typography
              key={i}
              sx={{
                maxWidth: 120,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                  textUnderlineOffset: 1,
                },
              }}
            >
              <Link to={v.url}>{v.text}</Link>
            </Typography>
          )
      })}
    </Breadcrumbs>
  )
}
